module.exports = __webpack_public_path__ + "img/ewm2.0a7bd1df.png";